import React from "react";
import CertificationItem from "./CertificationItem";

function CertificationList({ certifications, onEdit, onDelete }) {
    return (
        <div>
            {certifications.length > 0 ? (
              <div className="row row-cols-2 mt-2">
                {certifications.map((certification) => (
                  <div className="col-6" key={certification.id}>
                    <CertificationItem
                      certification={certification}
                      onEdit={() => onEdit(certification)}
                      onDelete={() => onDelete(certification.id)}
                    />
                  </div>

                ))}
              </div>
            ) : (

            <div className="text-center">
                <h4>No Certifications</h4>
                <p className="text-muted-small">No certifications added yet. Add your certifications to build your CV.</p>
            </div>
          )}
    </div>
  );
}

export default CertificationList;